import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IAC_ENVIRONMENT } from '@iac-environment';
import { sha1 } from 'js-sha1';

// NOTE: SHA-1 is imposed by the Storyblok validation protocol and cannot be changed.
// This guard is a soft client-side check only — not a security boundary.
export const IAC_STORYBLOK_GUARD: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const queryParams = router.currentNavigation()?.finalUrl?.queryParams;

  if (queryParams) {
    const spaceId = queryParams['_storyblok_tk[space_id]'];
    const timestamp = queryParams['_storyblok_tk[timestamp]'];
    const token = queryParams['_storyblok_tk[token]'];

    if (spaceId && timestamp && token) {
      const preToken = `${spaceId}:${IAC_ENVIRONMENT.storyblokToken}:${timestamp}`;
      const hashToken = sha1(preToken);

      if (hashToken === token && parseInt(timestamp) > Date.now() / 1000 - 3600) {
        return true;
      }
    }
  }

  // Replace the Storyblok preview path segment and redirect via the Angular router.
  // router.parseUrl() prevents the raw string from being passed directly to navigateByUrl.
  const redirectUrl = state.url.replace('/app-sb/', '/app/');
  return router.parseUrl(redirectUrl);
};
